import { BaseHelper } from './BaseGraphQLAPIHelper';

export const getCouponTransactions = (afterCursor = null, search = {}) => {
  let searchString = `, orderBy: "${search.rank ? '-pk' : 'pk'}"`;
  if (search?.sort) {
    searchString = `, orderBy: "${search?.sort}"`;
  }
  if (search.searchKey) {
    searchString += `, customerName: "${search.searchKey}"`;
  }
  if (search.record_type) {
    searchString += `, typeIn: "${search.record_type}"`;
  }
  if (search?.ssoUid) {
    searchString += `, customerSsoUid: "${search?.ssoUid}"`;
  };

  if (search.expired_date) {
    switch (search.expired_date) {
      case 'absolute':
        if (search.absolute) {
          const expiredDateRange = search.absolute.split(',');
          searchString += `, absoluteGte: "${expiredDateRange[0]}", absoluteLte: "${expiredDateRange[1]}"`;
        }
        break;
      case 'relativeDay':
        if (search.relativeDay) {
          searchString += `, relativeDay: ${search.relativeDay}`;
        }
        break;
      default:
        searchString += `, allTime: true`;
        break;
    }
  }

  const query = `{
        couponTransactions(
          first: 20,
          after: "${afterCursor}"${searchString}
        ) {
          totalCount
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              pk
              type
              pointsSpent
              creationDate
              customer {
                pk
                ssoUid
                firstName
                lastName
                nickname
                membershipId
              }
              campaign {
                name
                earningCampaignTypeEarningRule {
                    pk
                    name
                  }
              }
              coupon {
                id
                pk
                effectiveDate
                expiryDate
                serialNumber
                template {
                    name
                    validPeriodType
                    absoluteEffectiveDate
                    absoluteExpiryDate
                    numberOfDaysToExpireAfterAcquisition
                  }
              }
              administrator {
                pk
                username
              }
            }
          }
        }
      }`;
  const variables = {
    input: {},
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getCouponTransaction = (couponTransactionID) => {
  const query = `
  {
    couponTransaction(id: "${couponTransactionID}") {
      id
      pk
      type
      pointsSpent
      creationDate
      usedAt
      customer {
        pk
        ssoUid
        firstName
        lastName
        nickname
        membershipId
      }
      campaign {
        name
        earningCampaignTypeEarningRule {
          pk
          name
        }
      }
      coupon {
        id
        pk
        effectiveDate
        expiryDate
        template {
          name
          validPeriodType
          absoluteEffectiveDate
          absoluteExpiryDate
          numberOfDaysToExpireAfterAcquisition
        }
      }
      administrator {
        pk
        username
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getPointTransactionRecords = (afterCursor = '', search = {}) => {
  // let searchString = `, orderBy: "${search.rank ? '-pk' : 'pk'}"`;
  let searchString = `, orderBy: "-pk"`;
  if (search?.sort) {
    searchString = `, orderBy: "${search?.sort}"`;
  }
  if (search.type === 'REMOVE') {
    searchString += `, pointTypeIn: "TYPE_POINT_REMOVE"`;
  } else if (search.type === 'ADD') {
    searchString += `, pointTypeIn: "TYPE_POINT_ADD"`;
  }
  if (search.searchKey) {
    searchString += `, customerName: "${search.searchKey}"`;
  }
  if (search.record_type) {
    searchString += `, transactionTypeIn: "${search.record_type}"`;
  }
  if (search.value) {
    const valueRange = search.value.split(',');
    searchString += `, valueGte: ${valueRange[0]}, valueLte: ${valueRange[1]}`;
  }
  if (search.create_date) {
    searchString += `, creationDateEqual: "${search.create_date}"`;
  }

  const query = `
  {
    pointTransactions(
      first: 20,
      after: "${afterCursor}",
      hideBeVoidRecords: false${searchString}
    ) {
      totalCount
      maxPointValue
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          eventIdentifier
          customer {
            pk
            ssoUid
            firstName
            lastName
            nickname
            membershipId
          }
          pointType
          value
          transactionType
          remarks
          creationDate
          usedType
          usedRemark
          content
          usedDate
          adminVoidTransaction {
            pk
            eventIdentifier
            transactionType
          }
          expireAtDate
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getOnePointTransactionRecord = (pointRecordID) => {
  const query = `
  {
    pointTransaction(id: "${pointRecordID}") {
      id
      pk
      eventIdentifier
      customer {
        pk
        ssoUid
        firstName
        lastName
        nickname
      }
      pointType
      value
      transactionType
      remarks
      creationDate
      usedType
      usedRemark
      usedDate
      adminVoidTransaction {
        pk
        eventIdentifier
        transactionType
      }
      expireAtDate
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createPointAddTypeRecord = (inputBody) => {
  const query = `
  mutation AddPoints($input: AddPointsInput!) {
    addPoints(input: $input) {
      success
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createPointRemoveTypeRecord = (inputBody) => {
  const query = `
  mutation RemovePoints($input: RemovePointsInput!) {
    removePoints(input: $input) {
      success
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getTransactions = (afterCursor = '', search) => {
  let searchString = `, orderBy: "${search.rank ? '-pk' : 'pk'}"`;
  if (search?.sort) {
    searchString = `, orderBy: "${search?.sort}"`;
  }
  if (search.searchKey) {
    searchString += `, nameIdOid: "${search.searchKey}"`;
  }
  if (search.transaction_type) {
    searchString += `, transactionTypeIn: "${search.transaction_type}"`;
  }
  if (search.partners_type) {
    searchString += `, partnersTypeIn: "${search.partners_type}"`;
  }
  if (search.offline_event_type) {
    searchString += `, offlineEventTypeIn: "${search.offline_event_type}"`;
  }
  if (search.online_event_type) {
    searchString += `, onlineEventTypeIn: "${search.online_event_type}"`;
  }
  if (search.creation_date) {
    searchString += `, creationDateEqual: "${search.creation_date}"`;
  }
  if (search.approved_by) {
    searchString += `, approvedByIn: "${search.approved_by}"`;
  }
  if (search.ai_status) {
    searchString += `, aiStatusIn: "${search.ai_status}"`;
  }
  if (search.spot_check_status) {
    searchString += `, spotCheckStatusIn: "${search.spot_check_status}"`;
  }
  if (search.user_criteria) {
    searchString += `, userCriteria: "${search.user_criteria}"`;
  }

  if (search.sku_pattern_can_be_detected) {
    searchString += `, skuPatternCanBeDetected: ${search.sku_pattern_can_be_detected}`;
  }

  if (search?.ssoUid) {
    searchString += `, customerSsoUid: "${search?.ssoUid}"`;
  };

  if (search.is_octopus_transaction) {
    searchString += `, isOctopusTransaction: ${search.is_octopus_transaction}`;
  }

  const query = `
  {
    transactions(
      first: 20,
      after: "${afterCursor}"${searchString}
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          date
          transactionType
          merchantName
          skuPatternCanBeDetected
          customer {
            pk
            ssoUid
            firstName
            lastName
            nickname
            membershipId
          }
          store {
            pk
            name
            id
            brand {
              pk
              name
            }
          }
          onlineEventType
          offlineEventType
          isOctopusTransaction
          creationDate
          invoiceId
          totalValue
          totalRewardCarbon
          totalRewardPoint
          totalRewardCoupon
          totalRewardAmount
          skuPatternCanBeDetected
          approvedBy
          aiStatus
          spotCheckStatus
          partnersType
          orderId
          amount
          campaign {
            id
            name
          }
          couponSet {
            edges {
              node {
                template {
                  name
                }
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getRecentTransactions = (page = 1, { types, uid, id }) => {
  const searchString = `, orderBy: "-pk",referenceId: ${id} customerSsoUid: "${uid}", transactionTypeIn: "${types}"`;
  const query = `
  {
    paginatedTransactions(
      perPage: 5,page: ${page}${searchString}
    ) {
      page
      hasNext
      hasPrev
      totalCount
      items {
          id
          pk
          date
          transactionType
          offlineEventType
          spotCheckStatus
          totalRewardAmount
          receiptImage
          photoTakingItems {
            edges {
              node {
                id
                pk
                name
                storeSubcategory {
                  pk
                  id
                  name
                  category {
                    pk
                    id
                    name
                  }
                }
                quantity
              }
            }
          }
        }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getTransaction = (id, searchParams = {}) => {
   // Convert the search parameters to the corresponding GraphQL parameters
   const paramMappings = {
    'search': 'nameIdOid',
    'transaction_type': 'transactionTypeIn',
    'approved_by': 'approvedByIn',
    'offline_event_type': 'offlineEventTypeIn',
    'sku_pattern_can_be_detected': 'skuPatternCanBeDetected',
    'ai_status': 'aiStatusIn',
    'spot_check_status': 'spotCheckStatusIn',
    'user_criteria': 'userCriteria',
    'creation_date': 'creationDateEqual',
  };

  // Build parameters string for the GraphQL query
  const nextTransactionParams = Object.entries(searchParams)
    .filter(([key]) => paramMappings[key])
    .map(([key, value]) => {
      // Format the value based on parameter type
      const paramName = paramMappings[key];
      let formattedValue = value;
      
      // Special handling for boolean parameters
      if (paramName === 'skuPatternCanBeDetected') {
        // Convert string 'true'/'false' to boolean without quotes
        formattedValue = value === 'true' ? true : false;
      } 
      // Handle array-type parameters that need comma separation
      else if (paramName.endsWith('In') && !value.includes(',')) {
        formattedValue = `"${value}"`;
      } else if (paramName.endsWith('In')) {
        formattedValue = `"${value}"`;
      } else {
        formattedValue = `"${value}"`;
      }
      
      return `${paramName}: ${formattedValue}`;
    })
    .join(', ');


  const query = `
  {
    transaction(id: "${id}") {
      id
      pk
      nextTransactionPk${nextTransactionParams ? `(${nextTransactionParams})` : ''}
      nextSpotCheckTransaction${nextTransactionParams ? `(${nextTransactionParams})` : ''}
      date
      oclDate
      duplicatedWithOclRecord
      duplicatedWithReceiptRecord
      transactionType
      creationDate
      customer {
        pk
        ssoUid
        membershipId
        firstName
        lastName
        nickname
        markedLabel {
          edges {
            node {
              labelType
              amount
            }
          }
        }
      }
      store {
        pk
        id
        name
      }
      merchantName
      staffName
      onlineEventType
      offlineEventType
      shippingFee
      otherCharge
      totalValue
      remarks
      shopifyOrderId
      shopifyOrderPayload
      posInvoiceId
      invoiceId
      receiptImage
      creditCardSlipImage
      campaign {
        id
        name
        earningCampaignTypeEarningRule {
          pk
          branchMapping
        }
      }
      purchasedItems {
        edges {
          node {
            id
            pk
            name
            sku
            category
            brand
            quantity
            value
          }
        }
      }
      photoTakingItems {
        edges {
          node {
            id
            pk
            name
            storeSubcategory {
              pk
              id
              name
              category {
                pk
                id
                name
              }
            }
            quantity
          }
        }
      }
      barcodeItems {
        edges {
          node {
            id
            pk
            storeSubcategory {
              pk
              id
              name
            }
            barcode {
              linkedBrand {
                showInBarcode
                barcodePartner
              }
              productName
            }
            submittedNewBarcode {
              productName
            }
            quantity
          }
        }
      }
      waterVolume
      totalRewardCarbon
      totalRewardPoint
      totalRewardAmount
      totalRewardCoupon
      smallHeading
      relatedTransactionType
      generalPurchaseSubType
      generalPurchasePaymentMethod
      rewardType
      rewardCarbonValue
      rewardPointValue
      translations {
          edges {
              node {
                  language
                  smallHeading
              }
          }
      }
      jointBeauty
      withinRadius
      buildingName
      recalledReason
      approvedBy
      spotCheckStatus
      couponSet {
        edges {
                node {
                template {
                    name
                }
                }
            }
      }
      couponQuantity
      partnersType
      orderId
      amount
      aiStatus
      aiTransactions {
            edges {
                node {
                    id
                    creationDate
                    lastModifiedDate
                    status
                    mediaId
                    dropOutProbability
                    dropOutApplicationId
                    dropOutSubjectId
                    dropOutApplicationName
                    errors
                    aiPhotoTakingItems {
                        totalCount
                        edges {
                            cursor
                            node {
                                id
                                creationDate
                                lastModifiedDate
                                name
                                quantity
                                pk
                            }
                        }
                    }
                }
            }
        }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const approveTransaction = (id) => {
  const query = `
  mutation ApproveTransaction($input: ApproveTransactionInput!) {
    approveTransaction(input: $input) {
      success
      error
    }
  }`;
  const variables = {
    input: {
      id: id,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const rejectTransaction = (id, rejectReasonId) => {
  const query = `
  mutation RejectTransaction($input: RejectTransactionInput!) {
    rejectTransaction(input: $input) {
      success
      error
    }
  }`;
  const variables = {
    input: {
      id: id,
      rejectReason: rejectReasonId,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const recallTransaction = (id, recalledReasonId, isSpotCheck) => {
  const query = `
  mutation RecallTransaction($input: RecallTransactionInput!) {
    recallTransaction(input: $input) {
      success
      error
    }
  }`;
  const variables = {
    input: {
      id: id,
      recalledReason: recalledReasonId,
      isSpotCheck: isSpotCheck,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};


export const bulkRecallTransaction = (transactions, recalledReasonId, isSpotCheck) => {
  const query = `
  mutation BulkRecallTransaction($input: BulkRecallTransactionInput!) {
    bulkRecallTransaction(input: $input) {
      results {
          id
          success
          error
      }
    }
  }`;
  const variables = {
    input: {
      ids: transactions,
      recalledReason: recalledReasonId,
      isSpotCheck: isSpotCheck,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};


export const bulkApproveTransaction = (transactions) => {
  const query = `
  mutation BulkApproveTransaction($input: BulkApproveTransactionInput!) {
    bulkApproveTransaction(input: $input) {
      results {
          id
          success
          error
      }
    }
  }`;
  const variables = {
    input: {
      ids: transactions,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const bulkPassSpotCheck = (transactions) => {
  const query = `
  mutation BulkPassSpotCheck($input: BulkPassSpotCheckInput!) {
    bulkPassSpotCheck(input: $input) {
      results {
          id
          success
          error
      }
    }
  }`;
  const variables = {
    input: {
      ids: transactions,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const passSpotCheck = (id) => {
  const query = `
  mutation PassSpotCheck($input: PassSpotCheckInput!) {
    passSpotCheck(input: $input) {
      success
      error
    }
  }`;
  const variables = {
    input: {
      id: id
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteTransactions = (ids) => {
  const query = `
  mutation DeleteTransactions($input: DeleteTransactionsInput!) {
    deleteTransactions(input: $input) {
      success
    }
  }`;
  const variables = {
    input: {
      ids: ids,
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createTransaction = (inputBody) => {
  const query = `
  mutation CreateTransaction($input: CreateTransactionInput!) {
    createTransaction(input: $input) {
      node {
        id
        pk
        date
        transactionType
        customer {
                  id
              }
        store {
                  id
              }
        staffName
        shippingFee
        otherCharge
        totalValue
        remarks
        posInvoiceId
        invoiceId
        receiptImage
        creditCardSlipImage
        offlineEventType
      }
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createTransactions = (inputBody) => {
  const query = `
  mutation CreateTransactions($input: CreateTransactionsInput!) {
    createTransactions(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateTransaction = (inputBody) => {
  const query = `
  mutation UpdateTransaction($input: UpdateTransactionInput!) {
    updateTransaction(input: $input) {
      node {
        id
        pk
        date
        transactionType
      }
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};


export const updateTransactionItems = (inputBody) => {
  const query = `
  mutation UpdateTransactionItems($input: UpdateTransactionItemsInput!) {
    updateTransactionItems(input: $input) {
      node {
        id
        pk
        date
        transactionType
        purchasedItems {
          edges {
            node {
              id
              pk
              name
              sku
              category
              brand
              quantity
              value
            }
          }
        }
      }
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateCustomerMarkedLabel = (payload) => {
  const query = `
  mutation UpdateCustomerMarkedLabels($input: UpdateCustomerMarkedLabelsInput!) {
    updateCustomerMarkedLabels(input: $input) {
        success
    }
  }
  `;
  const variables = {
    input: payload,
  };

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateTransactionJointBeauty = (inputBody) => {
  const query = `
  mutation UpdateTransactionJointBeauty($input: UpdateTransactionJointBeautyInput!) {
    updateTransactionJointBeauty(input: $input) {
        success
    }
  }
  `;
  const variables = {
    input: inputBody,
  };

  return BaseHelper.callGraphQLAPI({ query, variables });
}
